import { makeRequestGet, makeRequestGet2, makeRequestPut2 } from "../api";
import Cookies from "js-cookie";

function getToken() {
  return new Promise((resolve) => {
    const checkToken = () => {
      let token = Cookies.get("token");
      if (token) {
        resolve(token);
      } else {
        setTimeout(checkToken, 100); // Check again after 100ms
      }
    };
    checkToken();
  });
}

export async function getAdmin(id) {
  let token = await getToken();
  return makeRequestGet2(`admins/${id}`, token);
}

export async function putAdmin(id, data) {
  let token = await getToken();
  return makeRequestPut2(`admins/${id}`, data, token);
}
